"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urn2Guid = exports.trim = exports.parsePagination = exports.lineageUrn2ShortUrn = exports.lineageUrn2Guid = exports.isStringTooLong = exports.isReservedName = exports.isFolderUrn = exports.isEndWithPeriod = exports.isCancelledRequest = exports.hasSpecialCharacter = exports.guid2Urn = exports.getValue = exports.getRequestId = exports.getProduct = exports.getBrowserId = exports.folderUrn2ShortUrn = exports.folderUrn2Guid = exports.encodeUrn = exports.deprecatedWarning = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _buffer = require("buffer");
var _get = _interopRequireDefault(require("lodash/get"));
var _lowerCase = _interopRequireDefault(require("lodash/lowerCase"));
var _trim = _interopRequireDefault(require("lodash/trim"));
var _docsHttpClient = require("@adsk/docs-http-client");
var _consts = require("./consts");
var _excluded = ["next", "nextUrl"];
/**
 * Simple wrapper for lodash trim
 *
 * @param str - The target string
 * @returns The trimmed string
 */
var trim = exports.trim = function trim(str) {
  return (0, _trim["default"])(str, undefined, undefined);
};

/**
 * Mark a method as deprecated and log a warning message
 *
 * @param oldMethod - The deprecated method name
 * @param newMethod - The new method name for replacement
 */
var deprecatedWarning = exports.deprecatedWarning = function deprecatedWarning(oldMethod, newMethod) {
  try {
    // Skip warning in production
    if (process.env.NODE_ENV === 'production') return;
  } catch (ex) {
    // Ignore the error
  }
  if (console && typeof console.warn === 'function') {
    if (newMethod) {
      console.warn("[DEPRECATED][DOCS SDK] ".concat(oldMethod, " is deprecated! Use ").concat(newMethod, " as instead."));
    } else {
      console.warn("[DEPRECATED][DOCS SDK] ".concat(oldMethod, " is deprecated!"));
    }
  }
};

/**
 * Base on lodash.get, but to add a protection for null value.
 *
 * @param entity - The target entity
 * @param key - The target key
 * @param defaultValue - The default value if the key is not found
 * @returns The value of the key
 */
var getValue = exports.getValue = function getValue(entity, key, defaultValue) {
  if (defaultValue === null || defaultValue === undefined) return (0, _get["default"])(entity, key);
  return (0, _get["default"])(entity, key) || defaultValue;
};

/**
 * Encode the urn besides the dot character
 * @param urn - The target urn
 * @returns The encoded urn
 */
var encodeUrn = exports.encodeUrn = function encodeUrn() {
  var urn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return encodeURIComponent(urn).split('.').join('%2E');
};

/**
 * Whether the name is a reserved name
 *
 * @param name - The target name
 * @returns True if the name is a reserved name
 */
var isReservedName = exports.isReservedName = function isReservedName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])(\.[^\.]*)?$/i.test(trim(name));
};

/**
 * Whether the string is end with period
 *
 * @param str - The target string
 * @returns True if the string is end with period
 */
var isEndWithPeriod = exports.isEndWithPeriod = function isEndWithPeriod() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /([\ \.])$/.test(trim(str));
};

/**
 * Whether the string has special character
 *
 * @param str - The target string
 * @returns True if the string has special character
 */
var hasSpecialCharacter = exports.hasSpecialCharacter = function hasSpecialCharacter() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /[\<\>\:\"\`\/\\\|\?\*\x00-\x1F]/.test(trim(str));
}; // eslint-disable-line no-control-regex

/**
 * Whether the string is too long
 * @param str - The target string
 * @param length - The max length
 * @returns True if the string is too long
 */
var isStringTooLong = exports.isStringTooLong = function isStringTooLong() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 255;
  return trim(str).length > length;
};

/**
 * Get the product based on the target url
 */
var getProduct = exports.getProduct = function getProduct(target) {
  var origin = target || '';
  if (!target && typeof window !== 'undefined' && window.location && window.location.origin) {
    origin = window.location.origin;
  }
  if (/^https:\/\/acc.*\.autodesk\.(com|eu)$/.test(origin) || /^(https|http):\/\/local\.acc-qa\.autodesk\.com:\d+/.test(origin)) return _consts.DOCS_PRODUCTS.ACC;
  if (/^https:\/\/docs\.b360.*\.autodesk\.com$/.test(origin) || /^(https|http):\/\/docs-local\.b360-qa\.autodesk\.com:\d+/.test(origin)) return _consts.DOCS_PRODUCTS.BIM;
  return null;
};

/**
 * Generate a tracking id based on url (product & tool)
 *
 * @param param - The tracking config
 * @returns Tracking id
 */
var getBrowserId = exports.getBrowserId = function getBrowserId(_ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    location = _ref.location;
  var product = getProduct(location.origin);
  // Return if no specific product
  if (!product) return "".concat(prefix, "_web").concat(suffix);
  if (product === _consts.DOCS_PRODUCTS.ACC) {
    var result = location.pathname.match(/^\/([A-Za-z0-9_-]+)\/([A-Za-z0-9_-]+)\/projects\//);
    if (result && result.length >= 3) {
      return "".concat(prefix, "_web_").concat((0, _lowerCase["default"])(product), "_").concat(result[1], "_").concat(result[2]).concat(suffix);
    }
    return "".concat(prefix, "_web_").concat((0, _lowerCase["default"])(product)).concat(suffix);
  }
  return "".concat(prefix, "_web_").concat((0, _lowerCase["default"])(product)).concat(suffix);
};

/**
 * Generate a request id for the request
 *
 * @param config - The request config
 * @returns The generated request id for tracking
 */
var getRequestId = exports.getRequestId = function getRequestId(config) {
  var buildId = (0, _get["default"])(config, 'buildId');
  var prefix = (0, _docsHttpClient.uuidV4)();
  var suffix = buildId ? "_".concat(buildId) : '';

  // Generate id for non-browser apps
  if (typeof window === 'undefined' || !window.location) return "".concat(prefix).concat(suffix);

  // Generate id for browser
  return getBrowserId({
    location: window.location,
    prefix: prefix,
    suffix: suffix
  });
};

/**
 * A common method to check if the request is cancelled
 * axios will return ECONNABORTED when canceling request / timeout,
 * use a common method to check the cancel request
 *
 * @param err - The error object from axios
 * @returns True if the request is cancelled
 */
var isCancelledRequest = exports.isCancelledRequest = function isCancelledRequest(err) {
  var error = err || {};
  return error.__CANCEL__ || error.ignore || error.code === 'ECONNABORTED' && error.message === 'Request aborted';
};
var SHORT_URN_LENGTH = 22;
var GUID_LENGTH = 36;

/**
 * Validate if the short urn is valid
 *
 * @param shortUrn - The target short urn
 * @returns True if the short urn is valid
 */
var isValidShortUrn = function isValidShortUrn(shortUrn) {
  return typeof shortUrn === 'string' && /^[a-zA-Z0-9-_]{22}$/.test(shortUrn);
};

/**
 * Parse short urn to guid
 * @param urn - The target short urn
 * @returns The guid generated from the short urn
 */
var urn2Guid = exports.urn2Guid = function urn2Guid(urn) {
  if (typeof urn !== 'string' || urn.length !== SHORT_URN_LENGTH) {
    return null;
  }
  var buffer = _buffer.Buffer.from(urn.replace(/-/g, '+').replace(/_/g, '/'), 'base64');
  return (0, _docsHttpClient.stringify)(buffer, 0);
};

/**
 * Parse guid back to short urn
 *
 * @param guid - The target guid string
 * @returns The short urn generated from the guid
 */
var guid2Urn = exports.guid2Urn = function guid2Urn(guid) {
  if (typeof guid !== 'string' || guid.length !== GUID_LENGTH) {
    return null;
  }
  return _buffer.Buffer.from((0, _docsHttpClient.parse)(guid)).toString('base64').replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
};

/**
 * The prefix of folder urn
 */
var FOLDER_PREFIX = ':fs.folder:co.';
/**
 * The prefix of lineage urn
 */
var LINEAGE_PREFIX = ':dm.lineage:';

/**
 * Split folder urn to short urn
 *
 * @param urn - The target folder urn
 * @returns The short urn of the folder urn
 */
var folderUrn2ShortUrn = exports.folderUrn2ShortUrn = function folderUrn2ShortUrn(urn) {
  if (typeof urn !== 'string' || urn.indexOf(FOLDER_PREFIX) < 0) return null;
  var idx = urn.indexOf(FOLDER_PREFIX) + FOLDER_PREFIX.length;
  var shortUrn = urn.slice(idx);
  return isValidShortUrn(shortUrn) ? shortUrn : null;
};

/**
 * Split lineage urn to short urn
 *
 * @param urn - The target lineage urn
 * @returns The short urn of the lineage urn
 */
var lineageUrn2ShortUrn = exports.lineageUrn2ShortUrn = function lineageUrn2ShortUrn(urn) {
  if (typeof urn !== 'string' || urn.indexOf(LINEAGE_PREFIX) < 0) return null;
  var idx = urn.indexOf(LINEAGE_PREFIX) + LINEAGE_PREFIX.length;
  var shortUrn = urn.slice(idx);
  return isValidShortUrn(shortUrn) ? shortUrn : null;
};

/**
 * Convert folder urn to guid
 *
 * @param urn - The target folder urn
 * @returns The guid of the folder urn
 */
var folderUrn2Guid = exports.folderUrn2Guid = function folderUrn2Guid(urn) {
  var shortUrn = folderUrn2ShortUrn(urn);
  return shortUrn ? urn2Guid(shortUrn) : null;
};

/**
 * Convert lineage urn to guid
 *
 * @param urn - The target lineage urn
 * @returns The guid of the lineage urn
 */
var lineageUrn2Guid = exports.lineageUrn2Guid = function lineageUrn2Guid(urn) {
  var shortUrn = lineageUrn2ShortUrn(urn);
  return shortUrn ? urn2Guid(shortUrn) : null;
};

/**
 * Validate if the urn is a folder urn
 * @param urn - The target urn
 * @returns True if the urn is a folder urn
 */
var isFolderUrn = exports.isFolderUrn = function isFolderUrn(urn) {
  return !!folderUrn2ShortUrn(urn);
};

/**
 * The backend API will follow forge standard to return next page info at `nextUrl` field instead of `next`
 * To keep capability with old code, we need to parse the `nextUrl` field to `next` field at FE sid
 *
 *  @param pagination - The server returned pagination object
 *
 * @returns Parsed pagination object
 */
var parsePagination = exports.parsePagination = function parsePagination(pagination) {
  var _ref2 = pagination || {},
    next = _ref2.next,
    nextUrl = _ref2.nextUrl,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return (0, _extends2["default"])({}, rest, {
    next: next || nextUrl
  });
};